/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountingFormulaRepresentation } from './AccountingFormulaRepresentation';
import {
    AccountingFormulaRepresentationFromJSON,
    AccountingFormulaRepresentationFromJSONTyped,
    AccountingFormulaRepresentationToJSON,
    AccountingFormulaRepresentationToJSONTyped,
} from './AccountingFormulaRepresentation';
import type { ResultType } from './ResultType';
import {
    ResultTypeFromJSON,
    ResultTypeFromJSONTyped,
    ResultTypeToJSON,
    ResultTypeToJSONTyped,
} from './ResultType';

/**
 * 
 * @export
 * @interface AccountingMetricUpdateRequest
 */
export interface AccountingMetricUpdateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountingMetricUpdateRequest
     */
    name?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountingMetricUpdateRequest
     */
    lc?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AccountingMetricUpdateRequest
     */
    unit?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountingMetricUpdateRequest
     */
    visible?: boolean;
    /**
     * all features that are assigned to the metric
     * @type {Array<string>}
     * @memberof AccountingMetricUpdateRequest
     */
    licenseFeatures?: Array<string>;
    /**
     * 
     * @type {ResultType}
     * @memberof AccountingMetricUpdateRequest
     */
    resultType?: ResultType;
    /**
     * 
     * @type {Array<AccountingFormulaRepresentation>}
     * @memberof AccountingMetricUpdateRequest
     */
    formulas?: Array<AccountingFormulaRepresentation>;
}



/**
 * Check if a given object implements the AccountingMetricUpdateRequest interface.
 */
export function instanceOfAccountingMetricUpdateRequest(value: object): value is AccountingMetricUpdateRequest {
    return true;
}

export function AccountingMetricUpdateRequestFromJSON(json: any): AccountingMetricUpdateRequest {
    return AccountingMetricUpdateRequestFromJSONTyped(json, false);
}

export function AccountingMetricUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountingMetricUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'lc': json['lc'] == null ? undefined : json['lc'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'visible': json['visible'] == null ? undefined : json['visible'],
        'licenseFeatures': json['licenseFeatures'] == null ? undefined : json['licenseFeatures'],
        'resultType': json['resultType'] == null ? undefined : ResultTypeFromJSON(json['resultType']),
        'formulas': json['formulas'] == null ? undefined : ((json['formulas'] as Array<any>).map(AccountingFormulaRepresentationFromJSON)),
    };
}

export function AccountingMetricUpdateRequestToJSON(json: any): AccountingMetricUpdateRequest {
    return AccountingMetricUpdateRequestToJSONTyped(json, false);
}

export function AccountingMetricUpdateRequestToJSONTyped(value?: AccountingMetricUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'lc': value['lc'],
        'unit': value['unit'],
        'visible': value['visible'],
        'licenseFeatures': value['licenseFeatures'],
        'resultType': ResultTypeToJSON(value['resultType']),
        'formulas': value['formulas'] == null ? undefined : ((value['formulas'] as Array<any>).map(AccountingFormulaRepresentationToJSON)),
    };
}

